export default __webpack_public_path__ + "static/l_team_echofox_colored-d2f2bf9d0780cf2e9d0527c41afdadf0.svg";